import Vue from "vue";
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
Vue.$cookies.config("1D");
const Appoitments = {
  state: () => ({
    currentStep: 1,
    appointment: {},
    lastAppointmentDate: false,
    patient: Vue.$cookies.get("hmc-patient") || {},
    selectedBlock: [],
    appointmentType: localStorage.getItem("appointmentType")
      ? JSON.parse(localStorage.getItem("appointmentType"))
      : [],
    appTimeEdit: null
  }),
  mutations: {
    UPDATE_STEP_STATE(state, step) {
      state.currentStep = step;
    },
    SET_APPOINTMENT(state, appointment) {
      state.appointment = appointment;
    },
    SET_PATIENT(state, patient) {
      state.patient = patient;
    },
    SET_APPOINTMENT_TYPE(state, type) {
      state.appointmentType = type;
      localStorage.setItem("appointmentType", JSON.stringify(type));
    },
    SET_BLOCK(state, blocks) {
      state.selectedBlock = blocks;
    },
    SET_APP_TIME_EDIT(state, appointment) {
      state.appTimeEdit = appointment;
    }
  },
  actions: {
    UPDATE_STEP({ commit }, step) {
      commit("UPDATE_STEP_STATE", step);
    },
    SET_APPOINTMENT({ commit }, appointment) {
      commit("SET_APPOINTMENT", appointment);
    },
    SET_PATIENT({ commit }, patient) {
      commit("SET_PATIENT", patient);
      Vue.$cookies.set("hmc-patient", JSON.stringify(patient));
    },
    SET_APPOINTMENT_TYPE({ commit }, type) {
      commit("SET_APPOINTMENT_TYPE", type);
    },
    SET_BLOCK({ commit }, blocks) {
      commit("SET_BLOCK", blocks);
    }
  },
  getters: {
    currentStep: state => {
      return state.currentStep;
    },
    currentAppointment: state => {
      return state.appointment;
    },
    patient: state => {
      return state.patient;
    },
    appTimeEdit: state => {
      return state.appTimeEdit;
    },
    appointmentType: state => {
      return state.appointmentType;
    },
    selectedBlock: state => {
      return state.selectedBlock;
    }
  }
};

export default Appoitments;
